export default __webpack_public_path__ + "static/media/UnderlineIcon.ef3d679a.svg";